import type { ArtworkMedium } from "./artworkPaths";
import type { CommissionProjectChoiceId } from "../data/commissionOptions";

export type InquireArtworkParams = {
  medium: ArtworkMedium;
  id: string;
  name: string;
};

export function projectChoiceForMedium(
  medium: ArtworkMedium,
): CommissionProjectChoiceId {
  if (medium === "canvas") return "CANVAS_ORIGINAL";
  if (medium === "ai") return "BRAND_AI";
  return "ALBUM_DIGITAL";
}

export function inquireArtworkUrl({
  medium,
  id,
  name,
}: InquireArtworkParams): string {
  const params = new URLSearchParams({
    artwork: id,
    medium,
    name,
  });
  return `/contact?${params.toString()}#commission`;
}

export function parseInquireArtworkSearch(
  search: string,
): Partial<InquireArtworkParams> | null {
  const params = new URLSearchParams(search);
  const id = params.get("artwork");
  const medium = params.get("medium") as ArtworkMedium | null;
  const name = params.get("name");
  if (!id || !medium || !name) return null;
  if (medium !== "canvas" && medium !== "ai" && medium !== "digital") {
    return null;
  }
  return { id, medium, name };
}
